// extracted by mini-css-extract-plugin
module.exports = {"modal":"CreateOrEditListModal_modal__4ho9K","privatePopup":"CreateOrEditListModal_privatePopup__Haiz5","checkbox":"CreateOrEditListModal_checkbox__1MpkV"};